import type { ClientInfoDto } from '../dto';
import type { ClientInfo } from '../models';

export const mapClientInfoDtoToModel = (dto: ClientInfoDto): ClientInfo => ({
  ...dto,
  accounts: dto.accounts ?? [],
});

export const mapClientInfoListDtoToModel = (
  dto: ClientInfoDto[],
): ClientInfo[] => dto.map(mapClientInfoDtoToModel);
